export const LogSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_225_3054)">
      <path
        d="M4.99996 4.99996H15H4.99996ZM4.99996 8.33329H15H4.99996ZM9.99996 11.6666H15H9.99996ZM9.99996 15H15H9.99996ZM1.66663 17.8333V2.16663C1.66663 2.03402 1.7193 1.90684 1.81307 1.81307C1.90684 1.7193 2.03402 1.66663 2.16663 1.66663H17.8333C17.9659 1.66663 18.0931 1.7193 18.1868 1.81307C18.2806 1.90684 18.3333 2.03402 18.3333 2.16663V17.8333C18.3333 17.9659 18.2806 18.0931 18.1868 18.1868C18.0931 18.2806 17.9659 18.3333 17.8333 18.3333H2.16663C2.03402 18.3333 1.90684 18.2806 1.81307 18.1868C1.7193 18.0931 1.66663 17.9659 1.66663 17.8333V17.8333Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 15V11.6666H6.66667V15H5Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
